import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beSetupStripeSubscription';
const AT = actionType(ATAG);

const beSetupStripeSubscription = withOptions(({ salonId, intentId }) =>
  endpoint(H.post, 'stripe/:salonId/subscription/', {
    AT,
    name: ATAG,
    params: { salonId },
    data: { intent_id: intentId },
  }),
);

beSetupStripeSubscription.AT = AT;
beSetupStripeSubscription.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beSetupStripeSubscription;
